import { jsxs, jsx } from "react/jsx-runtime";
const IconSparkleSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "m9.918 8.852-2.447-.34a2.415 2.415 0 0 1-2.039-2.04l-.34-2.446c-.016-.136-.22-.136-.237 0l-.34 2.447a2.415 2.415 0 0 1-2.04 2.039l-2.446.34c-.136.017-.136.22 0 .238l2.447.34a2.415 2.415 0 0 1 2.039 2.039l.34 2.446c.016.136.22.136.237 0l.34-2.446a2.415 2.415 0 0 1 2.04-2.04l2.446-.34c.136-.016.136-.22 0-.237Zm-2.82-4.945 1.597.22c.697.103 1.24.647 1.342 1.343l.221 1.598a.085.085 0 0 0 .17 0l.221-1.598a1.586 1.586 0 0 1 1.342-1.342l1.598-.221a.085.085 0 0 0 0-.17l-1.598-.22a1.586 1.586 0 0 1-1.342-1.343l-.22-1.598a.085.085 0 0 0-.17 0l-.222 1.615a1.586 1.586 0 0 1-1.342 1.342l-1.597.221c-.102 0-.102.136 0 .153Zm8.887 7.544-1.904-.271a1.874 1.874 0 0 1-1.597-1.598l-.272-1.903c-.017-.119-.17-.119-.187 0l-.272 1.903a1.874 1.874 0 0 1-1.597 1.598l-1.903.271c-.119.018-.119.17 0 .187l1.903.272c.833.12 1.478.765 1.598 1.598l.271 1.903c.017.119.17.119.187 0l.272-1.903a1.875 1.875 0 0 1 1.598-1.598l1.902-.272c.12-.017.12-.17 0-.187Z" })
    ]
  }
);
export {
  IconSparkleSvg
};
